import { combineReducers } from 'redux';

import listCycles from './listcycles/reducer';
import common from './common/reducer';
import editMenu from './editmenu/reducer';
import listAppliedMenus from './listappliedmenus/reducer';

export default combineReducers({
  listCycles,
  common,
  editMenu,
  listAppliedMenus,
});



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/reducer.js